// extracted by mini-css-extract-plugin
export default {"root":"AJg3Zp","text":"XBysXl","button-wrapper":"k7dIZn","buttonWrapper":"k7dIZn","expand-control":"I0QZQ6","expandControl":"I0QZQ6"};